import { where } from "firebase/firestore";
import { useMemo } from "react";
import { Badge } from "react-bootstrap";
import { FaImage, FaTrash } from "react-icons/fa";

import { useFlightCollection } from "../../api/firestoreWrappers.generated.jsx";
import {
    getMissionState,
    STATE_CANCELLED,
    STATE_FAILED,
    STATE_MISSED,
    STATE_PENDING,
    STATE_RUNNING,
    STATE_SUCCEEDED,
} from "../../api/missionApi.jsx";
import { uploadStatusIsTodo } from "../../components/UploadStatusMessage";

export function MeasurementInfoString({ mission }) {
    const [flights] = useFlightCollection(
        mission.organizationId,
        mission.locationId,
        [where("mission.id", "==", mission.id)],
        { type: "map" },
    );
    const expectedImages = useMemo(() => {
        return Object.values(flights).reduce((sum, f) => {
            const m = f?.measurementInfo?.nr_measurements ?? 0;
            return sum + m;
        }, 0);
    }, [flights]);

    const nr_uploaded_measurements = mission?.measurements?.length || 0;

    if (expectedImages === undefined) {
        return nr_uploaded_measurements;
    } else {
        const inCollectingState =
            mission?.states?.collecting !== undefined
                ? mission.states.collecting === STATE_RUNNING ||
                  mission.states.collecting === STATE_PENDING
                : uploadStatusIsTodo(mission);

        let displayValue = "";

        if (
            (nr_uploaded_measurements > 0 || !inCollectingState) &&
            expectedImages > 0 &&
            nr_uploaded_measurements < expectedImages
        ) {
            displayValue = `${nr_uploaded_measurements}/${expectedImages}`;
        } else {
            displayValue = `${nr_uploaded_measurements || expectedImages}`;
        }

        return displayValue;
    }
}

export function MeasurementInfoVariant(mission) {
    const state = mission?.states?.uploading;
    switch (state) {
        case STATE_CANCELLED:
            return "secondary";
        case STATE_RUNNING:
            return "primary";
        case STATE_FAILED:
            return "danger";
        case STATE_SUCCEEDED:
            return "success";
        default:
            return "primary";
    }
}

export default function UploadInfoBadge({ mission, className }) {
    if (getMissionState(mission) === STATE_MISSED) return null;
    return (
        <Badge pill bg={MeasurementInfoVariant(mission)} className={className}>
            {mission.measurementsDeletedAt && <FaTrash className="me-1" />}
            <FaImage className="me-2" />
            <MeasurementInfoString mission={mission} />
        </Badge>
    );
}
